module.exports = __webpack_public_path__ + "img/Vellis.3b59a599.jpg";